// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1i8ra","notes":"Notes_notes__30yEw"};